import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideKeycloak,
  createInterceptorCondition,
  IncludeBearerTokenCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  withAutoRefreshToken,
  AutoRefreshTokenService,
  UserActivityService
} from 'keycloak-angular';
import { environment } from '../../../environments/environment';

// Anchor the bearer attach pattern to environment.apiUrl so a typo or a
// future third-party call to any other `/api/` URL cannot accidentally
// receive the user's access token. The previous /\/api\//i pattern would
// have leaked the token to any URL containing the substring.
const escapeRegex = (input: string) => input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const apiUrlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp('^' + escapeRegex(environment.apiUrl)),
  bearerPrefix: 'Bearer'
});

export const keycloakProvider: EnvironmentProviders = provideKeycloak({
  config: {
    url: environment.keycloak.url,
    realm: environment.keycloak.realm,
    clientId: environment.keycloak.clientId
  },
  initOptions: {
    onLoad: 'login-required',
    checkLoginIframe: false
  },
  features: [
    withAutoRefreshToken({
      onInactivityTimeout: 'logout',
      sessionTimeout: 300000
    })
  ],
  providers: [
    AutoRefreshTokenService,
    UserActivityService
  ]
});

export const bearerTokenConfig: Provider = {
  provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  useValue: [apiUrlCondition]
};
